import { render } from "./ProjectRow.vue?vue&type=template&id=465c89bd&scoped=true"
import script from "./ProjectRow.vue?vue&type=script&lang=js"
export * from "./ProjectRow.vue?vue&type=script&lang=js"

import "./ProjectRow.vue?vue&type=style&index=0&id=465c89bd&scoped=true&lang=css"

import exportComponent from "C:\\Development\\Portfolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465c89bd"]])

export default __exports__